import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, ArrowRight } from 'lucide-react';
import PageBanner from '../components/common/PageBanner';
import { Section, Head } from '../components/common/Primitives';
import { contact } from '../data/site';
import banner from '../assets/banners/contact.jpg';

const cards = [
  { Icon: Phone, title: 'Our phone', text: contact.phone, href: contact.phoneHref },
  { Icon: Mail, title: 'Our email', text: contact.email, href: contact.emailHref },
  { Icon: MapPin, title: 'Our address', text: contact.address },
];

const Contact = () => (
  <div>
    <PageBanner
      image={banner}
      kicker="Contact"
      title="Talk to us"
      lead="About membership, a farm visit, or the nutrient system itself. A person reads everything that comes in."
    />

    <Section tone="paper">
      <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
        {cards.map(({ Icon, title, text, href }) => {
          const inner = (
            <>
              <span className="w-14 h-14 rounded-2xl grid place-items-center bg-forest/10 text-forest mx-auto">
                <Icon className="w-6 h-6" />
              </span>
              <h2 className="mt-6 font-display font-semibold text-[1.25rem] text-ink">{title}</h2>
              <p className="mt-2.5 text-soil/70 text-[15px] leading-relaxed break-words">{text}</p>
            </>
          );
          return href ? (
            <a
              key={title}
              href={href}
              className="rounded-2xl bg-chalk ring-1 ring-soil/10 p-8 text-center hover:ring-forest/40 transition-colors"
            >
              {inner}
            </a>
          ) : (
            <div key={title} className="rounded-2xl bg-chalk ring-1 ring-soil/10 p-8 text-center">
              {inner}
            </div>
          );
        })}
      </div>
    </Section>

    <Section tone="soil">
      <div className="max-w-3xl mx-auto text-center">
        <Head
          tone="dark"
          eyebrow="Two common reasons to write"
          title="Membership, or the technology"
          center
        />
        <div className="mt-12 grid sm:grid-cols-2 gap-4 text-left">
          <Link
            to="/membership"
            className="group rounded-xl bg-white/[0.04] ring-1 ring-white/10 p-7 hover:ring-lime/40 transition-colors"
          >
            <h3 className="font-display font-semibold text-[1.25rem] text-paper">
              Request an invitation
            </h3>
            <p className="mt-2.5 text-paper/60 text-[14.5px] leading-relaxed">
              Enrollment is capped at 500 families. Tell us a little about your household and we
              will let you know where things stand.
            </p>
            <span className="mt-5 inline-flex items-center gap-2 text-lime text-[14px] font-medium">
              Membership
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </span>
          </Link>

          <Link
            to="/farm-tech/system"
            className="group rounded-xl bg-white/[0.04] ring-1 ring-white/10 p-7 hover:ring-lime/40 transition-colors"
          >
            <h3 className="font-display font-semibold text-[1.25rem] text-paper">
              Ask about the system
            </h3>
            <p className="mt-2.5 text-paper/60 text-[14.5px] leading-relaxed">
              The architecture, the safety gates, the component choices: it is all published, and
              we are happy to go deeper than the page does.
            </p>
            <span className="mt-5 inline-flex items-center gap-2 text-lime text-[14px] font-medium">
              Farm Tech
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </span>
          </Link>
        </div>
      </div>
    </Section>
  </div>
);

export default Contact;
